export default {
  GET_SURVEY_RESULT_CDC: (state) => state.survey_result_cdc,
  GET_IMMEDIATE_MEASURES: (state) => state.immediate_measures,
  GET_FACTORS: (state) => state.factors,
  GET_ATTRIBUTES: (state) => state.attributes,
  GET_ROOT_CAUSES: (state) => state.root_causes,
  GET_DEALER_PREVENTIVE_MEASURES: (state) => state.dealer_preventive_measures,
};
